/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropMemberPointsResponse } from './DropMemberPointsResponse';
import {
    DropMemberPointsResponseFromJSON,
    DropMemberPointsResponseFromJSONTyped,
    DropMemberPointsResponseToJSON,
    DropMemberPointsResponseToJSONTyped,
} from './DropMemberPointsResponse';

/**
 * 
 * @export
 * @interface DropMePointsResponse
 */
export interface DropMePointsResponse {
    /**
     * 
     * @type {DropMemberPointsResponse}
     * @memberof DropMePointsResponse
     */
    points?: DropMemberPointsResponse;
}

/**
 * Check if a given object implements the DropMePointsResponse interface.
 */
export function instanceOfDropMePointsResponse(value: object): value is DropMePointsResponse {
    return true;
}

export function DropMePointsResponseFromJSON(json: any): DropMePointsResponse {
    return DropMePointsResponseFromJSONTyped(json, false);
}

export function DropMePointsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropMePointsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'points': json['points'] == null ? undefined : DropMemberPointsResponseFromJSON(json['points']),
    };
}

export function DropMePointsResponseToJSON(json: any): DropMePointsResponse {
    return DropMePointsResponseToJSONTyped(json, false);
}

export function DropMePointsResponseToJSONTyped(value?: DropMePointsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'points': DropMemberPointsResponseToJSON(value['points']),
    };
}

